import React from 'react'

import SocialIcon from '~/components/social-icon'

import CopyButton from './copy-button'

interface Props {
  title: string
  shareUrl: string
}

const ShareLinks: React.FC<Props> = ({ title, shareUrl }) => {
  const fullContent = `${title} \n${shareUrl}`

  return (
    <>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
        target="_blank"
        aria-label="Compartilhar no Linkedin"
        className="hover:text-hover-color"
      >
        <SocialIcon className="w-6 h-6" name="linkedin" />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${title}`}
        target="_blank"
        aria-label="Compartilhar no Twitter"
        className="hover:text-hover-color"
      >
        <SocialIcon className="w-6 h-6" name="twitter" />
      </a>
      <a
        href={`https://api.whatsapp.com/send?text=${fullContent}`}
        data-action="share/whatsapp/share"
        target="_blank"
        aria-label="Compartilhar no WhatsApp"
        className="hover:text-hover-color"
      >
        <SocialIcon className="w-6 h-6" name="whatsapp" />
      </a>
      <a
        href={`mailto:?subject=${title}&body=${fullContent}`}
        target="_blank"
        aria-label="Compartilhar no Email"
        className="hover:text-hover-color"
      >
        <SocialIcon className="w-6 h-6" name="email" />
      </a>
      <CopyButton shareUrl={shareUrl} />
    </>
  )
}

export default ShareLinks
